// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"46":"0a9688eccbec4150","618":"cc455262af640b09","648":"988c34e534f6d503","814":"7326b85f89e5066e","860":"8d262b3c37879612"}[chunkId] + ".js";
};